import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { parse } from "@babel/parser";
import * as t from "@babel/types";
import { parseLegacyModule } from "./modules/parseLegacyModule.js";
import { parseFile } from "./modules/parseFile.js";
import { collectModuleErrors } from "./modules/collectModuleErrors.js";
export function parseView(source, options) {
  var _options$libs;
  var app = {
    appType: "view",
    modules: new Map(),
    files: [{
      filePath: "/View.tsx",
      content: source
    }].concat(_toConsumableArray((_options$libs = options === null || options === void 0 ? void 0 : options.libs) !== null && _options$libs !== void 0 ? _options$libs : [])),
    constants: new Map(),
    errors: []
  };
  var ast;
  try {
    ast = parse(source, {
      plugins: ["jsx", "typescript"],
      sourceType: "module",
      errorRecovery: true
    });
  } catch (error) {
    app.errors.push({
      message: "Failed to parse TSX: ".concat(error),
      node: null,
      severity: "fatal",
      filePath: "/View.tsx"
    });
    return app;
  }
  var _iterator = _createForOfIteratorHelper(ast.program.body),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var stmt = _step.value;
      if (t.isExportDefaultDeclaration(stmt)) {
        if (t.isFunctionDeclaration(stmt.declaration)) {
          parseFile("/View.tsx", app, ast, options);
          collectModuleErrors(app);
          return app;
        }
        break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  parseLegacyModule("/View.tsx", app, ast, options);
  collectModuleErrors(app);
  return app;
}
//# sourceMappingURL=parseView.js.map